import { COMPANY } from 'api';
import { appPathStrategy, getCompanyName } from 'utils';

const loadImg = async (path: COMPANY) => {
  const logo = (await import(`./${path}/logo.png`)).default;

  return { logo };
};

const companyName = getCompanyName();

export const { logo } = await loadImg(appPathStrategy(companyName));
